module.exports = __webpack_public_path__ + "static/pokedex-79481580622222a33ebf46047417be5d.jpg";